import type { Rating } from '../scoring/config';

/** Mbps: whole numbers from 10 up, one decimal below (no false precision). */
export function formatMbps(value: number | undefined): string {
  if (value === undefined) return '–';
  if (value >= 10) return String(Math.round(value));
  return (Math.round(value * 10) / 10).toFixed(1);
}

export function formatMs(value: number | undefined): string {
  return value === undefined ? '–' : String(Math.round(value));
}

export function formatDataUsed(bytes: number): string {
  if (bytes >= 1e9) return `${(bytes / 1e9).toFixed(1)} GB`;
  if (bytes >= 1e6) return `${Math.round(bytes / 1e6)} MB`;
  return '<1 MB';
}

export const RATING_LABEL: Record<Rating, string> = {
  excellent: 'EXCELLENT',
  good: 'GOOD',
  fair: 'FAIR',
  poor: 'POOR',
};
